import AdminOnly from "./AdminOnly";

export default AdminOnly;
